//@ts-nocheck

import { CardActions } from '@mui/material';
import AuthHeader from '../../components/AuthHeader/AuthHeader';
import BoxedIcon from '../../components/BoxedIcon/BoxedIcon';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { XGButton } from 'xg-cl';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './ForgotPasswordSuccess.css';
import DottedPaginator from '../../components/DottedPaginator/DottedPaginator';
import { useNavigate } from 'react-router-dom';
import * as PropTypes from 'prop-types';

/**
 * This is the forgot password success page component.
 *
 * @namespace Pages
 */

const ForgotPasswordSucess = ({ id }) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/login');
  };

  return (
    <Box
      id={id}
      sx={{ display: 'flex', flexDirection: 'column' }}
      data-testid='forgot-password-success-page'
    >
      <AuthHeader
        icon={
          <BoxedIcon
            id='checkmark-boxed-icon'
            icon={
              <CheckCircleOutlineIcon
                className='forgot-password-success-icon'
                sx={{ fontSize: '28px' }}
              />
            }
          />
        }
        id='forgot-password-success-header'
        title='Password reset'
        text='Your password has been successfully reset. Click below to log in magically.'
        data-testid='forgot-password-success-auth-header'
      />
      <Card
        sx={{
          padding: '32px 40px 32px 40px',
          borderRadius: '12px',
          marginBottom: '32px',
          boxShadow:
            '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);'
        }}
      >
        <CardActions sx={{ padding: 0 }}>
          <XGButton
            id='go-log-in-button'
            text='Log in'
            type='primary'
            size='large'
            variant='contained'
            style={{ width: '100%' }}
            onClick={handleOnClick}
            data-testid='forgot-passoword-success-button'
          />
        </CardActions>
      </Card>
      <DottedPaginator dots={4} id='forgot-password-paginator' selected={4} />
    </Box>
  );
};

ForgotPasswordSucess.propTypes = {
  id: PropTypes.string.isRequired
};
export default ForgotPasswordSucess;
